module.exports = __webpack_public_path__ + "img/egypt.7fed7cda.svg";